import addDays from 'date-fns/addDays'

import { successResponseMockStructure } from './successResponseMockStructure'

import { Images_Demo } from '~images'
import { PointsHistoryItem } from '~types/pointsHistory'

export const pointsHistory: PointsHistoryItem[] = [
  {
    date: addDays(new Date(), -5),
    points: '300',
    title: 'Adidas Store',
    subtitle: '30% off',
    type: 'redeem',
    image: Images_Demo.SHOES as unknown as string,
    logo: Images_Demo.LOGO_ADIDAS as unknown as string,
    codeActive: false,
  },
  {
    date: addDays(new Date(), -6),
    points: '150',
    title: 'Bitcoin payment',
    subtitle: 'Nike Shop, Warsaw PL',
    type: 'earn',
    image: Images_Demo.BITCOIN_3 as unknown as string,
  },
  {
    date: addDays(new Date(), -7),
    points: '200',
    title: 'Money exchange',
    subtitle: 'RPay App',
    type: 'earn',
    image: Images_Demo.BITCOIN_4 as unknown as string,
  },
  {
    date: addDays(new Date(), -2),
    points: '400',
    title: 'Douglas store',
    subtitle: '25% discount',
    type: 'redeem',
    image: Images_Demo.PARFUME as unknown as string,
    logo: Images_Demo.LOGO_DOUGLAS as unknown as string,
    codeActive: false,
  },
  {
    date: addDays(new Date(), -5),
    points: '400',
    title: 'Adidas Store',
    subtitle: '28% discount',
    type: 'redeem',
    image: Images_Demo.SHOES as unknown as string,
    logo: Images_Demo.LOGO_ADIDAS as unknown as string,
    codeActive: true,
  },
  {
    date: addDays(new Date(), -5),
    points: '300',
    title: 'Douglas store',
    subtitle: '25% discount',
    type: 'redeem',
    image: Images_Demo.PARFUME as unknown as string,
    logo: Images_Demo.LOGO_DOUGLAS as unknown as string,
    codeActive: false,
  },
  {
    date: addDays(new Date(), -5),
    points: '800',
    title: 'Bitcoin payment',
    subtitle: 'Nike Shop, Warsaw PL',
    type: 'earn',
    image: Images_Demo.BITCOIN_3 as unknown as string,
  },
  {
    date: addDays(new Date(), -5),
    points: '800',
    title: 'Bitcoin payment',
    subtitle: 'Nike Shop, Warsaw PL',
    type: 'earn',
    image: Images_Demo.BITCOIN_3 as unknown as string,
  },
  {
    date: addDays(new Date(), -5),
    points: '800',
    title: 'Bitcoin payment',
    subtitle: 'Nike Shop, Warsaw PL',
    type: 'earn',
    image: Images_Demo.BITCOIN_3 as unknown as string,
  },
]

export const mockPointsHistoryResponse = successResponseMockStructure({ pointsHistory })
